import React from "react";
import { Switch, Route } from "react-router";
import ProductCsvUploadPage from "pages/fulfillment/ProductCsvUploadPage";
import FulfillmentProductIndexPage from "pages/fulfillment/FulfillmentProductIndexPage";
import FulfillmentProductCreatePage from "pages/fulfillment/FulfillmentProductCreatePage";
import FulfillmentProductDetailsPage from "pages/fulfillment/FulfillmentProductDetailsPage";

const FulfillmentProductRouter = () => {
  return (
    <Switch>
      <Route exact path="/organizations/:organization_id/products" component={FulfillmentProductIndexPage} />
      <Route path="/organizations/:organization_id/products/create" component={FulfillmentProductCreatePage} />
      <Route path="/organizations/:organization_id/products/upload-csv" component={ProductCsvUploadPage} />
      <Route
        exact
        path="/organizations/:organization_id/products/:product_id"
        component={FulfillmentProductDetailsPage}
      />
    </Switch>
  );
};

export default FulfillmentProductRouter;
